"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _Theme = require("../../../Theme/Theme.variables");

var _IconBase = require("./IconBase");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var LapelPin =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LapelPin, _PureComponent);

  function LapelPin() {
    _classCallCheck(this, LapelPin);

    return _possibleConstructorReturn(this, _getPrototypeOf(LapelPin).apply(this, arguments));
  }

  _createClass(LapelPin, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          width = _this$props.width,
          height = _this$props.height;
      var color = (0, _Theme.variables)(this.props)[this.props.color];
      return _react.default.createElement(_IconBase.IconBase, _extends({
        width: width,
        height: height,
        className: className,
        style: style,
        viewBox: "0 0 14 14",
        version: "1.1",
        fill: "none"
      }, this.props), _react.default.createElement("title", null, "Lapel Pin Icon"), _react.default.createElement("path", {
        d: "M9.22192 7.0001C8.48075 8.56481 6.91604 9.6354 5.02192 9.6354C2.46898 9.6354 0.410156 7.57657 0.410156 5.02363C0.410156 2.47069 2.46898 0.411865 5.02192 0.411865C5.68075 0.411865 6.25722 0.576571 6.83369 0.741277",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), _react.default.createElement("path", {
        d: "M6.99857 9.22363C5.43387 8.48245 4.36328 6.91775 4.36328 5.02363C4.36328 2.47069 6.4221 0.411865 8.97504 0.411865C11.528 0.411865 13.5868 2.47069 13.5868 5.02363C13.5868 5.68245 13.4221 6.25893 13.2574 6.8354",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), _react.default.createElement("path", {
        d: "M6.99839 4.77637C8.5631 5.51754 9.63369 7.08225 9.63369 8.97637C9.63369 11.5293 7.57486 13.5881 5.02192 13.5881C2.46898 13.5881 0.410156 11.5293 0.410156 8.97637C0.410156 8.23519 0.574862 7.57637 0.821921 6.9999",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), _react.default.createElement("path", {
        d: "M4.85938 7.00004C5.60055 5.43533 7.16526 4.36475 8.97702 4.36475C11.53 4.36475 13.5888 6.42357 13.5888 8.97651C13.5888 11.5295 11.53 13.5883 8.97702 13.5883C8.23584 13.5883 7.57702 13.4236 7.00055 13.1765",
        stroke: color,
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    }
  }]);

  return LapelPin;
}(_react.PureComponent);

LapelPin.displayName = 'LapelPin'; // Prop Types

LapelPin.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  color: _propTypes.default.string
};
LapelPin.defaultProps = {
  className: '',
  style: {},
  width: '14',
  height: '14',
  color: 'black'
};

var _default = (0, _styledComponents.withTheme)(LapelPin);

exports.default = _default;